var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.showSpinner)?_c('div',{staticClass:"lds-dual-ring"}):_vm._e(),_vm._v(" "+_vm._s(_vm.$t('addToCart'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }